<template>
  <div class="course-requirement req">
    <div class="reqinfo">
      <div class="course-name req-name">
        {{name}}
      </div>

      <!-- Display attempts, credit hours and minimum grade -->
      <div v-if="req.advanced" class="req-item">Credit Hours: {{req.credits}}</div>
      <div class="req-item" v-else>Credit Hours: {{req.course.minimum_credits}}</div>
      <div class="req-item">Minimum Grade: {{req.minimum_grade}}</div>
      <div v-if="req.advanced" class="req-item">Attempts: {{req.attempts}}</div>


      <div class="clear"></div>

      <div class="course-description" v-if="req.course.description">
        Course Description: {{req.course.description}}
      </div>

      <div class="course-prereq" v-if = 'req.course.prereq'>
        Prerequisites:
        <requisites-string
          :operand = 'req.course.prereq'
          requisiteType = 'prereq'
        ></requisites-string>
      </div>

      <div class="course-coreq" v-if = 'req.course.coreq'>
        Corequisites:
        <requisites-string
          :operand = 'req.course.coreq'
          requisiteType = 'coreq'
        ></requisites-string>
      </div>
    </div>
  </div>
</template>

<script>
  import { RequisitesString } from 'vue-course-requisite'

  export default {
    name: 'course',

    // Properties
    // Req - The requirement object
    props: ['req'],

    components: {
      RequisitesString
    },

    methods: {
      // used to roll credit count up to parent requirement sets
      computeMinimumCredits() {
        return this.req.credits
      }
    },

    computed: {
      name() {
        const course = this.req.course
        return course.name === course.full_number ? course.name : `${course.full_number} - ${course.name}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// course_requirement.vue?15f4f92a